function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
var LINE_HEIGHT = 22;
function getBulletStyle(size) {
    return {
        borderRadius: Math.ceil(size / 2),
        width: size,
        height: size,
        marginTop: LINE_HEIGHT / 2 - size / 2 + 1
    };
}
/**
 * A UI element similar to a `<ul>` HTML tag. Allows for some style
 * customization
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-133}
 */ export var UnorderedList = function(param) {
    var color = param.color, items = param.items, customLabels = param.customLabels, _param_size = param.size, size = _param_size === void 0 ? 'normal' : _param_size, style = param.style, testID = param.testID, textColor = param.textColor, weight = param.weight;
    var theme = useTheme().theme;
    color || (color = theme.color.primary100);
    textColor || (textColor = theme.color.gray200);
    return /*#__PURE__*/ _jsx(View, {
        spacing: size === 'small' ? 4 : 8,
        style: [
            {
                alignSelf: 'stretch'
            },
            style
        ],
        testID: testID,
        children: items.map(function(item, i) {
            var _customLabels_item;
            return /*#__PURE__*/ _jsxs(View, {
                row: true,
                spacing: size === 'large' ? 16 : 8,
                style: {
                    alignItems: 'flex-start'
                },
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: [
                            _object_spread_props(_object_spread({}, getBulletStyle(8)), {
                                backgroundColor: color
                            }),
                            size === 'small' ? getBulletStyle(5) : null,
                            size === 'large' ? getBulletStyle(12) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            flex: 1
                        },
                        children: (_customLabels_item = customLabels === null || customLabels === void 0 ? void 0 : customLabels[item]) !== null && _customLabels_item !== void 0 ? _customLabels_item : /*#__PURE__*/ _jsx(Text, {
                            text: item,
                            size: size === 'large' ? 20 : size === 'small' ? 15 : 17,
                            lineHeight: 22,
                            color: textColor,
                            weight: weight !== null && weight !== void 0 ? weight : 'semibold'
                        })
                    })
                ]
            }, item + i);
        })
    });
};
